module.exports = __webpack_public_path__ + "static/media/CBNImg10.83928aad.webp";